// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import config from './components/config'
import tipBox from './components/tip-box/tip-box'
import signMsg from './components/sign-msg/sign-msg'
import audioPlay from './components/audio'
import server from './components/server'
import  './components/comnFun'
import { Upload,Dialog } from 'element-ui';

import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'



Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(server)
Vue.use(config)
Vue.use(tipBox)
Vue.use(audioPlay)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(signMsg)

Vue.use(VueAwesomeSwiper)


/* eslint-disable no-new */
window.eventbus = new Vue();
new Vue({
    el: '#app',
    router,
    bus: new Vue(),
    components: { App },
    template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js